import { createStructuredSelector } from "reselect";
import {
    TPI_PRODUCT,
    TPI_PRODUCT_SUCCESS,
    TPI_PRODUCT_ERROR,
    TPI_SUPPLIER,
    TPI_SUPPLIER_SUCCESS,
    TPI_SUPPLIER_ERROR,
    TPI_DELIVERY_ORDER,
    TPI_DELIVERY_ORDER_SUCCESS,
    TPI_DELIVERY_ORDER_ERROR,
    TPI_STATUS_DOCS,
    TPI_STATUS_DOCS_SUCCESS,
    TPI_STATUS_DOCS_ERROR,
    TPI_LIST,
    TPI_LIST_SUCCESS,
    TPI_LIST_ERROR,
    TPI_LIST_SEARCH_CHANGE,
    TPI_LIST_PAGE_SET,
    TPI_EDIT_MODAL_SET,
    TPI_EDIT_CHANGE_SET,
    TPI_EDIT,
    TPI_EDIT_SUCCESS,
    TPI_EDIT_ERROR,
    TPI_MTO_MODAL_SET,
    TPI_MTO_CHANGE_SET,
    TPI_MTO_DETAIL,
    TPI_MTO_DETAIL_SUCCESS,
    TPI_MTO_DETAIL_ERROR,
    TPI_EDIT_MTO_MODAL_SET,
    TPI_EDIT_MTO_CHANGE_SET,
    TPI_EDIT_MTO,
    TPI_EDIT_MTO_SUCCESS,
    TPI_EDIT_MTO_ERROR,
    TPI_PROJECTION_MAINTENANCE_DATES,
    TPI_PROJECTION_MAINTENANCE_DATES_SUCCESS,
    TPI_PROJECTION_MAINTENANCE_DATES_ERROR,
    TPI_DOCUMENTATION,
    TPI_DOCUMENTATION_SUCCESS,
    TPI_DOCUMENTATION_ERROR
} from "../../actions";

export const NAME = 'trackingInstallation';

export const TPIProduct = (data) => ({
    type: TPI_PRODUCT,
    payload: data
});

export const TPIProductSuccess = (data) => ({
    type: TPI_PRODUCT_SUCCESS,
    payload: data
});

export const TPIProductError = (error) => ({
    type: TPI_PRODUCT_ERROR,
    payload: error
});

export const TPISupplier = (data) => ({
    type: TPI_SUPPLIER,
    payload: data
});

export const TPISupplierSuccess = (data) => ({
    type: TPI_SUPPLIER_SUCCESS,
    payload: data
});

export const TPISupplierError = (error) => ({
    type: TPI_SUPPLIER_ERROR,
    payload: error
});

export const TPIDeliveryOrder = (data) => ({
    type: TPI_DELIVERY_ORDER,
    payload: data
});

export const TPIDeliveryOrderSuccess = (data) => ({
    type: TPI_DELIVERY_ORDER_SUCCESS,
    payload: data
});

export const TPIDeliveryOrderError = (error) => ({
    type: TPI_DELIVERY_ORDER_ERROR,
    payload: error
});

export const TPIStatusDocs = (data) => ({
    type: TPI_STATUS_DOCS,
    payload: data
});

export const TPIStatusDocsSuccess = (data) => ({
    type: TPI_STATUS_DOCS_SUCCESS,
    payload: data
});

export const TPIStatusDocsError = (error) => ({
    type: TPI_STATUS_DOCS_ERROR,
    payload: error
});

export const TPIList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: TPI_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const TPIListSuccess = (data) => ({
    type: TPI_LIST_SUCCESS,
    payload: data
});

export const TPIListError = (error) => ({
    type: TPI_LIST_ERROR,
    payload: error
});

export const TPIPageSet = (data) => ({
    type: TPI_LIST_PAGE_SET,
    payload: data
});

export const TPISearchChange = (data) => ({
    type: TPI_LIST_SEARCH_CHANGE,
    payload: data
});


export const TPIEditModalSet = (data) => ({
    type: TPI_EDIT_MODAL_SET,
    payload: data
});

export const TPIEditChangeSet = (data) => ({
    type: TPI_EDIT_CHANGE_SET,
    payload: data
});

export const TPIEdit = (page, num_page, orderBy, filters, data) => ({
    type: TPI_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const TPIEditSuccess = (message) => ({
    type: TPI_EDIT_SUCCESS,
    payload: message
});

export const TPIEditError = (error) => ({
    type: TPI_EDIT_ERROR,
    payload: error
});

export const TPIMtoModalSet = (data) => ({
    type: TPI_MTO_MODAL_SET,
    payload: data
});

export const TPIMtoChangeSet = (data) => ({
    type: TPI_MTO_CHANGE_SET,
    payload: data
});

export const TPIMtoDetail = (data) => ({
    type: TPI_MTO_DETAIL,
    payload: data
});

export const TPIMtoDetailSuccess = (message) => ({
    type: TPI_MTO_DETAIL_SUCCESS,
    payload: message
});

export const TPIMtoDetailError = (error) => ({
    type: TPI_MTO_DETAIL_ERROR,
    payload: error
});


export const TPIEditMtoModalSet = (data) => ({
    type: TPI_EDIT_MTO_MODAL_SET,
    payload: data
});

export const TPIEditMtoChangeSet = (data) => ({
    type: TPI_EDIT_MTO_CHANGE_SET,
    payload: data
});

export const TPIEditMto = (data) => ({
    type: TPI_EDIT_MTO,
    payload: data 
});

export const TPIEditMtoSuccess = (message) => ({
    type: TPI_EDIT_MTO_SUCCESS,
    payload: message
});

export const TPIEditMtoError = (error) => ({
    type: TPI_EDIT_MTO_ERROR,
    payload: error
});

export const TPIProjectionMaintenanceDates = (data) => ({
    type: TPI_PROJECTION_MAINTENANCE_DATES,
    payload: data
});

export const TPIProjectionMaintenanceDatesSuccess = (data) => ({
    type: TPI_PROJECTION_MAINTENANCE_DATES_SUCCESS,
    payload: data
});

export const TPIProjectionMaintenanceDatesError = (error) => ({
    type: TPI_PROJECTION_MAINTENANCE_DATES_ERROR,
    payload: error
});

export const TPIDocumentation = (data) => ({
    type: TPI_DOCUMENTATION,
    payload: data
});

export const TPIDocumentationSuccess = (data) => ({
    type: TPI_DOCUMENTATION_SUCCESS,
    payload: data
});

export const TPIDocumentationError = (error) => ({
    type: TPI_DOCUMENTATION_ERROR,
    payload: error
});


const trackingInstallation = (state) => state[NAME];

export const TrackingInstallationSelector = createStructuredSelector({
    trackingInstallation
})


